import { apiPost, apiRequest } from "../core/http/axios_api_v2";
import axiosV2 from "../core/http/axios_api_v2";

export default {

    //the tasks page's trash icon: asks, deletes, and takes the task out of the list it came from.
    //Resolves true once the server has deleted it (the page then fetches its page again), false
    //when the user said no.
    //(it used to be a second `deleteTask` in this object - the later deleteTask(taskId) below
    //replaced it, so the icon posted tasks/delete/[object Object] and nothing was ever deleted)
    async confirmAndDeleteTask(taskToDelete,tasks) {

        let confirmation = !!await planup.$swal({
            title: 'מחיקת משימה',
            text: 'האם למחוק את המשימה ' + '"' + taskToDelete.name + '"' + '?',
            showCancelButton: true,
            confirmButtonText: 'מחק',
            cancelButtonText: 'ביטול',
            confirmButtonColor: '#ff5370',
        }).catch(err => { })

        if (!confirmation)
            return false;

        //the ?. operator was not compiling!!!!!!!!!!!!!!!! 
        if (taskToDelete.recurrence && taskToDelete.recurrence['on']){
            await this.handleDeleteRecurrence(taskToDelete);
        } 
        
        let deleting = apiPost(`tasks/delete/${taskToDelete.id}`);

        let index = tasks.indexOf(taskToDelete);
        if (index > -1)
            tasks.splice(index, 1);

        await deleting;
        return true;

    },

    async handleDeleteRecurrence(task){


        let confirmation = !!await planup.$swal({
            title: 'משימה מחזורית',
            text: 'האם למחוק את שאר המשימות שנוצרו?',
            showCancelButton: true,
            confirmButtonText: 'מחק',
            cancelButtonText: 'ביטול',
            confirmButtonColor: '#ff5370',
        }).catch(err => { })


        if (!confirmation)
            return;

        console.log('deleting recurrence');

    },


    gotoAddNewTaskFromSearch(searchResult, date) {

        if (date) {
            planup.$router.push(`/customer/${searchResult.customerId}?newTask=${date.getTime()}`)
        } else {
            planup.$router.push(`/customer/${searchResult.customerId}?newTask`)
        }

    },



    getEventTasks: (eventId, callback, customerId) => {
        axiosV2(`tasks/getEventTasks/${eventId}` + (customerId ? `?customerId=${customerId}` : '')).then(response => callback(response.data));
    },



    async saveTask(taskData, hideSuccessAlert) {


        setNoon(taskData.date);


        let clone = shallowCopy(taskData);

        if (taskData.event?.id)
            clone.event = { id: clone.event.id }

        if (taskData.customer?.id)
            clone.customer = { id: clone.customer.id }







        return apiPost('tasks', clone, hideSuccessAlert).then(
            taskDataFromServer => {

                taskData.id = taskDataFromServer.id;
                planup.$handlers.calendarHandler.addItemToCache(taskData.date, 'task', taskData);
                return taskDataFromServer;

            }
        );
    },






    async markTask(id, done) {

        return apiPost(`/tasks/mark/${id}?done=${done ? 1 : 0}`)

    },


    // resolves once the server has it (the tasks page then moves the task to its other list)
    toggleTaskStatus(task) {

        task.done = !task.done;
        return this.markTask(task.id, task.done);
    },


    deleteTask(taskId){
        return apiPost(`tasks/delete/${taskId}`).then(


            
            response => {

                response.data
            }
            
        )
    },



    async getTask(taskId) {
        return axiosV2(`/tasks/${taskId}`).then(response => response.data);
    },

    async getTasks(limit) {
        return (await axiosV2(`/tasks?limit=${limit}`)).data;
    },

    // the /tasks page: { summary, sections: { overdue: { rows, total, page, perPage }, ... } }.
    // params: sections ('overdue,today,...'), page, perPage, summary (1), today / tomorrow / nextWeek
    // (the browser's midnights, ISO), assignee, customerId, taskType, from + to, q
    async getTasksBoard(params) {
        return (await axiosV2.get('/tasks/board', { params: params })).data;
    },

    // the page's customer filter: the customers that have tasks, [{ id, name }]
    async getTaskCustomers() {
        return (await axiosV2.get('/tasks/customers')).data;
    },

    // the page's panel: { created, createdBy, source, wasMilestone, followUpOf, entries }
    async getTaskHistory(taskId) {
        return (await axiosV2.get(`/tasks/history/${taskId}`)).data;
    },

    // the page's "דחייה": the task to another day (a Date - the browser's noon of it), its time kept
    rescheduleTask(taskId, date) {
        return apiPost(`tasks/reschedule/${taskId}`, { date: date ? date.toISOString() : null }, true);
    },

    // tasks dated between two Date objects (the homepage widget: today, or the range picked there)
    async getTasksBetween(start, end) {
        return (await axiosV2.get('/tasks', { params: { from: start.toISOString(), to: end.toISOString() } })).data;
    },

    // the account's users a task can be handed to ({ id, name, type }), into $store.state.taskAssignees
    // (the task modal's "מוקצה ל" reads the store; fetched again every time it opens - a tiny list)
    async loadAssignees() {
        let users = (await axiosV2.get('/tasks/assignees')).data;
        if (Array.isArray(users))
            planup.$store.state.taskAssignees = users;
        return planup.$store.state.taskAssignees;
    },

    // every task of the chain a task belongs to, first to last (one row = just the task itself)
    async getChain(taskId) {
        return (await axiosV2.get(`/tasks/chain/${taskId}`)).data;
    },


    generateLocalEmptyTask: () => {

        return {
            name: '',
            done: false,
            customer: null,
            event: null,
            date: new Date(),
            showInCalendar: true,
            time: null,
            hidden:false,
            //the user the task is for ({ id, name, type }) / who made it (the server sets that) /
            //the task it continues (a משימת המשך)
            assignedTo: null,
            createdBy: null,
            followUpOfId: null,
            recurrence: {
                on: false,
                repeatType: window.planup.$store.state.taskRecurrenceRepeatTypes[0],
                repeatCountType: window.planup.$store.state.taskRecurrenceRepeatCountTypes[0],
                endType: null,
                endDate: null,
                days: {
                    sun: null,
                    mon: null,
                    tue: null,
                    wed: null,
                    thu: null,
                    fri: null,
                    sat: null,
                }
            },
        }
    },



    milestonesToTasks(milestones, event, customer) {

        if (!milestones || !milestones.length)
            return;

        let tasks = [];
        milestones.forEach(milestone => {

            let task = this.generateLocalEmptyTask();
            task.event = event;
            task.customer = customer;
            task.name = milestone.name;
            task.description = milestone.details;
            task.crewMembers = milestone.crewMembers;
            task.wasMilestone = true;
            task.priority = milestone.priority;

            if (event.date && milestone.daysBeforeEvent) {

                task.date = new Date(event.date);
                task.date.setDate(event.date.getDate() - milestone.daysBeforeEvent);
            }

            this.saveTask(task, true);
            tasks.push(task);

        })

        this.setEventGotMilestoneTasks(event);

        return tasks;
    },


    setEventGotMilestoneTasks(event) {
        apiPost(`event/setEventGotMilestoneTasks/${event.id}`, null, true);
    },


    calendarTooltip(eventId) {
        return axiosV2.get(`/tasks/tooltip/${eventId}`).then(response => {

            let html = `
            
                <div style="text-align: center;color:rgb(119, 119, 119)">
                    ${planup.$globals.niceDate(response.data.date)}

                    ${response.data.time ? ' &nbsp; ' + response.data.time : ''}

                </div>
                <br>

                <div style="font-weight:bold;">

                    ${response.data.name}

                </div>

                <br>
            
            `;






            for (let i = 0; i < response.data?.customer?.contacts?.length; i++) {

                html += `<img class='eventTooltipContactImage' src="${planup.$handlers.customerHandler.getContactImage(response.data.customer.contacts[i])}"> ${response.data.customer.contacts[i].firstName}&nbsp;&nbsp;`

            }

            html += '<br>';
            html += '<br>';


            if (response.data?.taskType?.name)
                html += 'סוג משימה: ' + response.data.taskType.name + '<br>'


            if (response.data?.crewMembers && response.data.crewMembers.length)
                html += 'צוות : ' + response.data.crewMembers.map(member => member.name).join(', ') + '<br>'


            return html;

        })
    },



}